import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react";
import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          // 共通レイアウトのみ（bg/text は種別ごとに指定して競合を避ける）
          toast: "cn-toast !rounded-2xl !backdrop-blur-xl !shadow-lg",
          // 通常・成功・情報は白の半透明すりガラス
          default: "!bg-white/80 !border-white/60 !text-gray-900",
          success: "!bg-white/80 !border-white/60 !text-gray-900",
          info: "!bg-white/80 !border-white/60 !text-gray-900",
          // 警告・エラーは視認性のためダークを維持（警告色の意味を保つ）
          warning: "!bg-zinc-800 !border-zinc-700 !text-white",
          error: "!bg-zinc-800 !border-zinc-700 !text-white",
          // アイコンはトーストのテキスト色に追従（白背景→濃色 / 暗背景→白）
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
